import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { shippingApi } from './shipping.api';
import type { ShipmentsListParams } from '../types';
import { STALE_TIME } from '@/lib/query/stale-times';

export const shipmentKeys = {
  all: ['shipments'] as const,
  lists: () => [...shipmentKeys.all, 'list'] as const,
  list: (filters: ShipmentsListParams) =>
    [...shipmentKeys.lists(), filters] as const,
  details: () => [...shipmentKeys.all, 'detail'] as const,
  detail: (id: number) => [...shipmentKeys.details(), id] as const,
  metrics: () => [...shipmentKeys.all, 'metrics'] as const
};

export const shippingQueries = {
  list: (filters: ShipmentsListParams = {}) =>
    queryOptions({
      queryKey: shipmentKeys.list(filters),
      queryFn: () => shippingApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: shipmentKeys.detail(id),
      queryFn: () => shippingApi.getById(id),
      enabled: id > 0
    }),

  metrics: () =>
    queryOptions({
      queryKey: shipmentKeys.metrics(),
      queryFn: () => shippingApi.getMetrics(),
      staleTime: STALE_TIME.metrics
    })
};
